export default __webpack_public_path__ + "static/media/noimage.ed4a2a56.png";